import {getEvent} from '../../../../../selectors/event'
import {isChooseSeatNoFee} from '../../../../../selectors/navigation'
import {getShowPricingOptionsPlace} from '../../../../../selectors/seating/mode'
import {connect} from '../../../../runtime-context/context'
import {PricingOptionModalRuntimeProps} from './interfaces'
import {PricingOptionModal as Presentation} from './pricing-option-modal'

const mapRuntime = ({
  state,
  actions: {setShowPricingOptionsPlace, selectPlacePricingOption},
}): PricingOptionModalRuntimeProps => ({
  place: getShowPricingOptionsPlace(state),
  event: getEvent(state),
  setShowPricingOptionsPlace,
  selectPlacePricingOption,
  noServiceFee: isChooseSeatNoFee(state),
})

export const PricingOptionModal = connect<{}, PricingOptionModalRuntimeProps>(mapRuntime)(Presentation)
